// extracted by mini-css-extract-plugin
export var collapsedSummary = "_ou-0";